export default __webpack_public_path__ + "static/media/Home-foto-header-corporate-Tower-viajes-desk.993ac978.jpg";